<template>
  <div
    class="sm:col-span-1 flex flex-col"
    v-if="props.adminView && props.editMode"
  >
    <label :for="model.label" class="text-sm font-medium text-gray-500">{{
      model.label
    }}</label>
    <div class="relative mt-2 rounded-md shadow-sm">
      <input
        :type="props.type || 'text'"
        :name="model.label"
        :id="model.key"
        v-model="model.data"
        class="p-2 block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 focus:outline-none sm:text-sm sm:leading-6"
        :placeholder="model.placeholder"
      />
      <div
        class="hidden pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
        :id="'icon-error_' + model.key"
      >
        <i class="fas fa-exclamation-circle text-red-500" aria-hidden="true" />
      </div>
    </div>
    <p :id="'error_' + model.key" class="mt-2 text-sm text-red-600"></p>
  </div>
  <div class="sm:col-span-1" v-else-if="adminView">
    <dt class="text-sm font-medium text-gray-500">
      {{ model.label || "LinkedIn" }}
    </dt>
    <a
      as="a"
      :href="model.data"
      target="_blank"
      class="mt-1 text-sm text-blue-600 hover:text-blue-500"
    >
      Öppna <i class="fas fa-external-link-alt ml-1"></i>
    </a>
  </div>
  <div class="w-full" v-else>
    <div class="flex items-baseline gap-2">
      <label
        class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1"
        for="name"
      >
        {{ model.label }}
      </label>
      <a :href="model.placeholder" target="_blank">
        <i
          class="text-darkGray-1 fa-solid fa-circle-question text-xs"
          title="Öppna guide i ny flik"
        ></i>
      </a>
    </div>
    <div class="relative w-full">
      <a
        v-if="props.disabled && props.admin"
        :href="model.data"
        target="_blank"
        :class="
          model?.data && model?.data?.length > 0
            ? 'text-blue-1 hover:underline'
            : 'text-darkGray-2 pointer-events-none'
        "
      >
        {{
          model?.data && model?.data?.length > 0
            ? "Öppna länk i ny flik"
            : "länk saknas"
        }}
      </a>
      <input
        v-else
        @input="customChange"
        class="appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-1 sm:py-3 px-4 leading-tight focus:bg-white focus:border-blue-1 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed relative"
        :id="model.key"
        type="text"
        v-model="model.data"
        :placeholder="model.label"
        :required="props.required ? true : null"
        :disabled="props.disabled ? true : null"
      />
      <div
        :id="'icon-error_' + model.key"
        class="hidden absolute top-0 bottom-0 right-0 left-auto w-[60px] flex flex-row justify-center items-center"
        @mouseenter="showErrorMessage"
        @mouseleave="hideErrorMessage"
      >
        <i class="text-red-2 fa-solid fa-circle-info"></i>
      </div>
    </div>
    <div v-show="showingErrorMessage" class="relative z-50">
      <div
        class="absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md"
        :id="'outer-error_' + model.key"
      >
        <p
          class="font-medium text-sm text-red-2"
          :id="'error_' + model.key"
        ></p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref, shallowRef } from "vue";
import { defineEmits } from "@vue/runtime-core";
import * as dtos from "@/models/dtos";
// import { default } from '../../store/modules/notificationStore';
const emit = defineEmits(["change"]);
const props = defineProps({
  model: {
    required: false,
  },
  type: String,
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  admin: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};
let model = shallowRef(props.model as dtos.DynamicProperty);

function customChange(event: any) {
  emit("change", model.value);
}
</script>
